<template>
    <div id="about">
        <el-main class="about-section">
            <el-row align="middle" justify="center">
                <el-col :span="24">
                    <h2>关于我们</h2>
                    <el-divider>我们是集贸易、技术、软件、服务于一体的商贸公司</el-divider>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card>
                                <h3>专注东元品牌</h3>
                                <p>
                                    &emsp;&emsp;<b>上海德思贤科技有限公司</b>是一家集贸易、技术、服务于一体的商贸公司，是东元电机华东区的指定代理商，整机和配件型号齐全，性价比高，服务至上。专业经销东元低/高压电机、防爆电机、减速机、变频器、元件、控制器、伺服、智慧机电等。
                                </p>
                                <p>
                                    <b>低压电机：</b>GB-V系列、GB-F系列、变频电机、永磁电机、应用型电机、低压大功率异步电机等
                                </p>
                                <p>
                                    <b>高压电机：</b>高压异步、同步电机，TEFC、TEAAC、TEWAC、ODP、WPI、WPII等系列
                                </p>
                                <p><b>防爆电机：</b>气体隔爆、粉尘防爆系列，TEBY、TEBV、TEB4、TEBD、AESV等系列</p>
                                <p><b>智慧机电：</b>智能传感器、智能测温、智能电表等</p>
                                <p>
                                    <b>减速机：</b>斜齿轮减速机、蜗轮蜗杆减速机、TKM准双曲面减速机等
                                </p>
                                <p><b>变频器：</b>低/高压变频器，E710、M310、A510S、T310、S310、C310等系列</p>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card>
                                <el-image :src="authorizeImg"/>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card>
                                <el-image :src="motorImg"/>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script setup>
import {ref} from "vue"
import authorize from '@/assets/aboutImg/authorize.jpg'
import motor from '@/assets/aboutImg/motor.jpg'

const authorizeImg = ref(authorize)
const motorImg = ref(motor)
</script>

<style scoped>
.about-section {
    width: 70%;
    margin: auto;
}

.about-section h2 {
    font-size: 30px;
    text-align: center;
    margin-bottom: 30px;
}

p {
    text-align: center;
}

.el-card {
    text-align: left;
}

.el-card h3 {
    font-size: 24px;
    margin-bottom: 10px;
}

.el-card p {
    text-align: left;
    font-size: 15px;
    color: #666;
}
</style>